import { State } from "@/store/modules/system/index";

const setLoaderAction = ({ commit }, payload) => {
  commit("setLoader", payload);
};

const setUserPaperPlaneIdAction = ({ commit }, payload) => {
  commit("setUserPaperPlaneId", payload);
};

const setOpenPaperPlaneModalAction = ({ commit }, payload) => {
  commit("setOpenPaperPlaneModal", payload);
};
const setOpenUserInfoModalAction = ({ commit }, payload) => {
  commit("setOpenUserInfoModal", payload);
};

const setUserInfoIdAction = ({ commit }, payload) => {
  commit("setUserInfoId", payload);
};

const setWonderPointUrlAction = ({ commit }, payload) => {
  commit("setWonderPointUrl", payload);
};

const setOpenWonderPointModalAction = ({ commit }, payload) => {
  commit("setOpenWonderPointModal", payload);
};

const setDeviceNotificationAction = ({ commit }, payload) => {
  commit("setDeviceNotification", payload);
};

const setOpenChangeSpaceModalAction = ({ commit }, payload) => {
  commit("setOpenChangeSpaceModal", payload);
};

const setShowUserTechnicalInfoAction = ({ commit }, payload) => {
  commit("setShowUserTechnicalInfo", payload);
};

const setPusherAction = ({ commit }, payload) => {
  commit("setPusher", payload);
};

const setSpaceUserTechnicalInfoReceivedAction = ({ commit }, payload) => {
  commit("setSpaceUserTechnicalInfoReceived", payload);
};

const setGraphicClientVersionAction = ({ commit }, payload: string) => {
  commit("setGraphicClientVersion", payload);
};

const setShowWelcomeAction = ({ commit }, payload: boolean) => {
  commit("setShowWelcome", payload);
};

const setShowCompleteOnBoardingAction = ({ commit }, payload: boolean) => {
  commit("setShowCompleteOnBoarding", payload);
};

const setSuggestionsNotificationsAction = ({ commit }, payload) => {
  commit("setSuggestionsNotifications", payload);
};

const setMaintenanceModalAction = ({ commit }, payload) => {
  commit("setMaintenanceModal", payload);
};

const setMaintenanceStartAction = ({ commit }, payload) => {
  commit("setMaintenanceStart", payload);
};

const setMaintenaceFinishAction = ({ commit }, payload) => {
  commit("setMaintenaceFinish", payload);
};

const setMaintenanceMessageError = ({ commit }, payload) => {
  commit("setMaintenanceMessageError", payload);
};

const setShowPhotonErrorModalAction = ({ commit }, payload) => {
  commit("setShowPhotonErrorModal", payload);
};

const setShowExitModalAction = ({ commit }, payload) => {
  commit("setShowExitModal", payload);
};

const setZoomAction = ({ commit }, payload) => {
  commit("setZoom", payload);
};

const setMaxZoomAction = ({ commit }, payload) => {
  commit("setMaxZoom", payload);
};

const setMinZoomAction = ({ commit }, payload) => {
  commit("setMinZoom", payload);
};

const setShowCameraOptionsAction = ({ commit }, payload) => {
  commit("setShowCameraOptions", payload);
};

const setShowTutorialModalAction = ({ commit }, payload) => {
  commit("setTutorialModal", payload);
};

const setTutorialTextAction = ({ commit }, payload) => {
  commit("setTutorialText", payload);
};

const setCallTimerAction = ({ commit }, payload) => {
  commit("setCallTimer", payload);
};

const setNotificationTutorialAction = ({ commit }, payload) => {
  commit("setNotificationTutorial", payload);
};

const setManageSpaceMenuActiveAction = ({ commit }, payload) => {
  commit("setManageSpaceMenuActive", payload);
};

const setConfirmModalBanAction = ({ commit }, payload) => {
  commit("setConfirmBanModal", payload);
};

const setConfirmBanModalDataAction = ({ commit }, payload) => {
  commit("setConfirmBanModalData", payload);
};

const setDescriptionBoothModalAction = ({ commit }, payload) => {
  commit("setDescriptionBoothModal", payload);
};

const setDescriptionBoothCountDownModalAction = ({ commit }, payload) => {
  commit("setDescriptionBoothCountDownModal", payload);
};

const setDescriptionBoothModalDataAction = ({ commit }, payload) => {
  commit("setDescriptionBoothModalData", payload);
};

const setDescriptionBoothTimeOutAction = ({ commit }, payload) => {
  commit("setDescriptionBoothTimeOut", payload);
};

const setVacationModalAction = ({ commit }, payload) => {
  commit("setVacationModal", payload);
};

const setShowGoodMorningModalAction = ({ commit }, payload) => {
  commit("showGoodMorningModal", payload);
};

const setBlockChangeEmojiAction = ({ commit }, payload) => {
  commit("blockChangeEmoji", payload);
};

const addReactionsAction = ({ commit }, payload) => {
  commit("addReactions", payload);
};

const removeReactionAction = ({ commit }, payload) => {
  commit("removeReaction", payload);
};

const setShowWebGLContextLostModalAction = ({ commit }, payload: boolean) => {
  commit("setShowWebGLContextLostModal", payload);
};

const setShowCloseWebinarModalAction = ({ commit }, { close, id }) => {
  commit("setShowCloseWebinarModal", close);
  commit("setWebinarCloseId", id);
};

const setShowCallErrorModalAction = ({ commit }, payload: boolean) => {
  commit("setShowCallErrorModal", payload);
};

const setSelecSuperSpaceIdAction = ({ commit }, payload: boolean) => {
  commit("setSelecSuperSpaceId", payload);
};

const setSelectedPinSuperSpaceIdAction = ({ commit }, payload: boolean) => {
  commit("setSelectedPinSuperSpaceId", payload);
};

const setPinCountDownModalAction = ({ commit }, payload) => {
  commit("setPinCountDownModal", payload);
};

const setShowPinModalAction = ({ commit }, payload) => {
  commit("setShowPinModal", payload);
};

const setPinTimeOutAction = ({ commit }, payload) => {
  commit("setPinTimeOut", payload);
};

const setSuperSpaceUserPaperPlaneIdAction = ({ commit }, payload) => {
  commit("setSuperSpaceUserPaperPlaneId", payload);
};

const setShowPinRoomModalAction = ({ commit }, payload) => {
  commit("setShowPinRoomModal", payload);
};

const setIsChangePinAction = ({ commit }, payload) => {
  commit("setIsChangePin", payload);
};

const setManageModalTypeAction = ({ commit }, payload) => {
  commit("setManageModalType", payload);
};

const setShowPosterAction = ({ commit }, payload) => {
  commit("setPoster", payload);
};

const setOpenPosterModalAction = ({ commit }, payload) => {
  commit("setOpenPosterModal", payload);
};

const setErrorGeneralClientGraphicAction = ({ commit }, payload) => {
  commit("setErrorGeneralClientGraphic", payload);
};

const setErrorDataGeneralClientGraphicAction = ({ commit }, payload) => {
  commit("setErrorDataGeneralClientGraphic", payload);
};

const setShowCallErrorRetryModalAction = ({ commit }, payload) => {
  commit("setShowCallErrorRetryModal", payload);
};

const setShowBirthdayModalAction = ({ commit }, payload) => {
  commit("setShowBirthdayModal", payload);
};

const setDataBirthdayModalAction = ({ commit }, payload) => {
  commit("setDataBirthdayModal", payload);
};

const setOpenChangeSpaceFavouriteModalAction = ({ commit }, payload) => {
  commit("setOpenChangeSpaceFavouriteModal", payload);
};

const setOpenNotepadButtonAction = ({ commit }, payload) => {
  commit("setOpenNotepadButton", payload);
};

const setOpenNotepadModalAction = ({ commit }, payload) => {
  commit("setOpenNotepadModal", payload);
};

const setCurrentRoomAction = ({ commit }, payload) => {
  commit("setCurrentRoom", payload);
};

const setShowCompleteOnBoardingTeamsAction = ({ commit }, payload: boolean) => {
  commit("setShowCompleteOnBoardingTeams", payload);
};

const setWaitingResponseTimeoutAction = ({ commit }, payload: any) => {
  commit("setWaitingResponseTimeout", payload);
};

const setRobotModalAction = ({ commit }, payload: any) => {
  commit("setRobotModal", payload);
};

const setEducationModalAction = ({ commit }, payload: any) => {
  commit("setEducationModal", payload);
};

const setEducationToolModalAction = ({ commit }, payload: any) => {
  commit("setEducationToolModal", payload);
};

const setEducationBotIdAction = ({ commit }, payload: any) => {
  commit("setEducationBotId", payload);
};

const setOpenSpotifyModalAction = ({ commit }, payload: boolean) => {
  commit("setOpenSpotifyModal", payload);
};

const setGameKillerModalAction = ({ commit }, payload: boolean) => {
  commit("setGameKillerModal", payload);
};

const setGameKillerInfoModalAction = ({ commit }, payload: boolean) => {
  commit("setGameKillerInfoModal", payload);
};

const setGameKillerVoteAndWinnerModalAction = ({ commit }, payload: boolean) => {
  commit("setGameKillerVoteAndWinnerModal", payload);
};

const setGameKillerWinnerAction = ({ commit }, payload: boolean) => {
  commit("setGameKillerWinner", payload);
};

const setReserveRoomModalAction = ({ commit }, payload: boolean) => {
  commit("setReserveRoomModal", payload);
};

const setCttiGameModalAction = ({ commit }, payload: boolean) => {
  commit("setCttiGameModal", payload);
};

const setShowAutoVideoEnterModalAction = ({ commit }, payload: boolean) => {
  commit("setShowAutoVideoEnterModal", payload);
};

const setAutoVideoAction = ({ commit }, payload: boolean) => {
  commit("setAutoVideo", payload);
};

const setReservePhysicalRoomModalAction = ({ commit }, payload: boolean) => {
  commit("setReservePhysicalRoomModal", payload);
};

const setAssistantAction = ({ commit }, payload: any) => {
  commit("setAssistant", payload);
};

const setAccessTokenGoogleAction = ({ commit }, payload: string) => {
  commit("setAccessTokenGoogle", payload);
};

const setAccessTokenHotmailAction = ({ commit }, payload: string) => {
  commit("setAccessTokenHotmail", payload);
};

const setShowModalPlanWarningPremiumAction = ({ commit }, payload: string) => {
  commit("setShowModalPlanWarningPremium", payload);
};

export default {
  setLoaderAction,
  setUserPaperPlaneIdAction,
  setOpenPaperPlaneModalAction,
  setOpenUserInfoModalAction,
  setUserInfoIdAction,
  setWonderPointUrlAction,
  setOpenWonderPointModalAction,
  setDeviceNotificationAction,
  setOpenChangeSpaceModalAction,
  setShowUserTechnicalInfoAction,
  setPusherAction,
  setSpaceUserTechnicalInfoReceivedAction,
  setGraphicClientVersionAction,
  setShowWelcomeAction,
  setShowCompleteOnBoardingAction,
  setSuggestionsNotificationsAction,
  setMaintenanceModalAction,
  setMaintenanceStartAction,
  setMaintenaceFinishAction,
  setMaintenanceMessageError,
  setShowPhotonErrorModalAction,
  setShowExitModalAction,
  setZoomAction,
  setMaxZoomAction,
  setMinZoomAction,
  setShowCameraOptionsAction,
  setShowTutorialModalAction,
  setTutorialTextAction,
  setCallTimerAction,
  setNotificationTutorialAction,
  setManageSpaceMenuActiveAction,
  setConfirmModalBanAction,
  setConfirmBanModalDataAction,
  setDescriptionBoothModalAction,
  setDescriptionBoothModalDataAction,
  setVacationModalAction,
  setShowGoodMorningModalAction,
  setBlockChangeEmojiAction,
  addReactionsAction,
  removeReactionAction,
  setDescriptionBoothTimeOutAction,
  setShowWebGLContextLostModalAction,
  setShowCloseWebinarModalAction,
  setDescriptionBoothCountDownModalAction,
  setShowCallErrorModalAction,
  setSelecSuperSpaceIdAction,
  setSelectedPinSuperSpaceIdAction,
  setPinCountDownModalAction,
  setShowPinModalAction,
  setPinTimeOutAction,
  setSuperSpaceUserPaperPlaneIdAction,
  setShowPinRoomModalAction,
  setIsChangePinAction,
  setManageModalTypeAction,
  setShowPosterAction,
  setOpenPosterModalAction,
  setErrorGeneralClientGraphicAction,
  setErrorDataGeneralClientGraphicAction,
  setShowCallErrorRetryModalAction,
  setShowBirthdayModalAction,
  setDataBirthdayModalAction,
  setOpenChangeSpaceFavouriteModalAction,
  setOpenNotepadButtonAction,
  setOpenNotepadModalAction,
  setCurrentRoomAction,
  setShowCompleteOnBoardingTeamsAction,
  setWaitingResponseTimeoutAction,
  setRobotModalAction,
  setEducationModalAction,
  setEducationToolModalAction,
  setEducationBotIdAction,
  setOpenSpotifyModalAction,
  setGameKillerModalAction,
  setGameKillerInfoModalAction,
  setGameKillerVoteAndWinnerModalAction,
  setGameKillerWinnerAction,
  setReserveRoomModalAction,
  setCttiGameModalAction,
  setShowAutoVideoEnterModalAction,
  setAutoVideoAction,
  setReservePhysicalRoomModalAction,
  setAssistantAction,
  setAccessTokenGoogleAction,
  setAccessTokenHotmailAction,
  setShowModalPlanWarningPremiumAction,
};
